// Definição para o modal de busca de Produtos
// Factory function - recebe filtros como parâmetros, sem magic strings

import { ST } from '@/constants/ST'
import { criarConfigBuscaTipoProduto } from '@/search-definitions/tipoProdutoSearch'

export const criarConfigBuscaProduto = (lstStatus = ST.Ativo, lstNaturezaItem = null) => {
  const filtrosFixos = { lstStatus }
  if (lstNaturezaItem) {
    filtrosFixos.lstNaturezaItem = lstNaturezaItem
  }
  return {
    label: 'Produto',
    placeholder: 'SKU ou Nome...',
    titulo: 'Buscar Produto',
    endpointApi: 'Produtos',
    idField: 'idProduto',
    displayField: 'sku',
    descField: 'nome',
    tabela: 'TipoProduto',
    tamanho: 'xl',
    colunasGrid: [
      { header: 'SKU', dataField: 'sku', width: '180px' },
      { header: 'Descrição', dataField: 'nome' },
      { header: 'NCM', dataField: 'codigoNcm', width: '100px' },
      { header: 'Natureza', dataField: 'lstNaturezaItem', width: '120px' },
      { header: 'Tipo', dataField: 'nomeTipoProduto', width: '180px' }
    ],
    camposFiltro: [
      { model: 'busca', label: 'Busca Livre (SKU, Nome, NCM)', tipo: 'text' },
      { model: 'codigoNcm', label: 'NCM', tipo: 'text' },
      {
        model: 'lstNaturezaItem',
        label: 'Natureza',
        tipo: 'listabusca',
        tabela: 'TipoProduto'
      },
      {
        model: 'idTipoProduto',
        label: 'Tipo de Produto',
        tipo: 'campobusca',
        configuracaoBusca: criarConfigBuscaTipoProduto()
      },
      { model: 'lstStatus', label: 'Status', tipo: 'hidden', value: lstStatus }
    ],
    filtrosFixos,
    // 🆕 Bloco de autocomplete
    autocomplete: {
      habilitado: true,
      minChars: 2,
      maxResults: 15,
      debounceMs: 350,
      campoBusca: 'busca',
      camposExibicao: [
        { dataField: 'sku', header: 'SKU', width: '120px' },
        { dataField: 'nome', header: 'Nome' }
      ],
      ordenarPor: 'sku',
      ordenarDirecao: 'asc'
    }
  }
}
